import { render, staticRenderFns } from "./SVGPhotoRotateRight45.vue?vue&type=template&id=37b47627&scoped=true&"
import script from "./SVGPhotoRotateRight45.vue?vue&type=script&lang=js&"
export * from "./SVGPhotoRotateRight45.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b47627",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37b47627')) {
      api.createRecord('37b47627', component.options)
    } else {
      api.reload('37b47627', component.options)
    }
    module.hot.accept("./SVGPhotoRotateRight45.vue?vue&type=template&id=37b47627&scoped=true&", function () {
      api.rerender('37b47627', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGPhotoRotateRight45.vue"
export default component.exports